export const PLACEHOLDER_BY_NAME = {
  name: 'Ex: Ilyas',
  company: 'Ex: SNCF Réseau',
  email: 'Ex: contact@entreprise.com',
  phone: 'Ex: +33 6 12 34 56 78',
  address: 'Ex: 12 rue de la Gare',
  city: 'Ex: Paris',
  postalCode: 'Ex: 75001',
  serialNumber: 'Ex: EXT-2024-001',
  inventoryNumber: 'Ex: INV-001',
  structure: 'Ex: PNDC/DDO',
  affectation: 'Ex: Brigade Nord',
  vehicleType: 'Ex: Camion citerne',
  vehicleRegistration: 'Ex: AB-123-CD',
  detailedType: 'Ex: CO2 2 kg',
  capacity: 'Ex: 6 kg',
  detailedLocation: 'Ex: Hall principal, niveau 2',
  location: 'Ex: Bureau 204, couloir principal...',
  recoveredBy: 'Ex: Ilyas',
  poste: 'Ex: Responsable sécurité',
  subject: 'Ex: Objet du message',
  notes: 'Observations, remarques particulières...',
  observation: 'Notes, anomalies constatées...',
  spareParts: 'Ex: Flexible neuf, manomètre remplacé...',
  physicalCondition: 'Ex: Bon état, quelques éraflures...',
  firstAidKit: 'Ex: Complet, bandages vérifiés...',
  message: 'Votre message...',
  quantity: 'Ex: 2',
  password: '••••••••',
  newPassword: 'Nouveau mot de passe (min. 8 caractères)',
  oldPassword: 'Saisissez votre mot de passe actuel',
  confirmPassword: 'Confirmez le nouveau mot de passe',
  planName: 'Ex: Bâtiment principal, Site Paris...',
  planLocation: 'Ex: 123 rue Example, Paris',
  planFloor: 'Ex: RDC, 1er étage, Zone A...',
};

export const PLACEHOLDER_BY_LABEL = [
  [/nom complet|nom d'utilisateur|^nom$/i, 'Ex: Ilyas'],
  [/nom du plan/i, 'Ex: Bâtiment principal, Entrepôt...'],
  [/nom du site/i, 'Ex: Site principal DOE'],
  [/entreprise|société/i, 'Ex: Nom de l\'entreprise'],
  [/e-?mail|mail/i, 'Ex: contact@entreprise.com'],
  [/téléphone|telephone|tél/i, 'Ex: +33 6 12 34 56 78'],
  [/adresse/i, 'Ex: 12 rue de la Gare, 75001 Paris'],
  [/ville/i, 'Ex: Paris'],
  [/code postal|postal/i, 'Ex: 75001'],
  [/n°\s*s[ée]rie|num[ée]ro de s[ée]rie|r[ée]f[ée]rence/i, 'Ex: EXT-2024-001'],
  [/inventaire/i, 'Ex: INV-001'],
  [/capacit[ée]/i, 'Ex: 6 kg'],
  [/emplacement/i, 'Ex: Hall principal, bureau 101...'],
  [/étage|etage|zone/i, 'Ex: RDC, 1er étage, Zone A...'],
  [/matricule/i, 'Ex: AB-123-CD'],
  [/structure/i, 'Ex: PNDC/DDO'],
  [/affectation/i, 'Ex: Brigade Nord'],
  [/v[ée]hicule/i, 'Ex: Camion citerne'],
  [/mot de passe actuel/i, 'Saisissez votre mot de passe actuel'],
  [/confirmer.*mot de passe/i, 'Confirmez le nouveau mot de passe'],
  [/nouveau mot de passe/i, 'Nouveau mot de passe (min. 8 caractères)'],
  [/mot de passe/i, '••••••••'],
  [/recherch/i, 'Rechercher...'],
  [/site/i, 'Ex: Site principal DOE'],
  [/accessoire/i, 'Ex: Flexible 70...'],
  [/quantit[ée]/i, 'Ex: 2'],
  [/poste/i, 'Ex: Responsable technique, Directeur...'],
  [/pi[èe]ces d[ée]tach[ée]es/i, 'Ex: Flexible neuf, manomètre remplacé...'],
  [/aspect physique|[ée]tat.*[ée]quipement/i, 'Ex: Bon état, quelques éraflures...'],
  [/bo[îi]te [àa] pharmacie/i, 'Ex: Complet, bandages vérifiés...'],
  [/notes internes|notes de suivi/i, 'Notes de suivi, actions entreprises...'],
  [/^notes$|note$/i, 'Observations, remarques particulières...'],
  [/observation/i, 'Notes, anomalies constatées...'],
  [/message/i, 'Votre message...'],
  [/sujet/i, 'Ex: Demande de devis, question...'],
];

export function resolveFieldPlaceholder({ placeholder, label, name, type }) {
  if (placeholder) return placeholder;
  if (type === 'date' || type === 'datetime-local' || type === 'time') return '';
  if (type === 'email') return 'Ex: contact@entreprise.com';
  if (type === 'tel') return 'Ex: +33 6 12 34 56 78';
  if (type === 'password') return '••••••••';
  if (type === 'number') return '0';
  if (type === 'search') return 'Rechercher...';
  if (name && PLACEHOLDER_BY_NAME[name]) return PLACEHOLDER_BY_NAME[name];
  if (label) {
    for (const [pattern, hint] of PLACEHOLDER_BY_LABEL) {
      if (pattern.test(label)) return hint;
    }
    return `Saisissez ${label.charAt(0).toLowerCase()}${label.slice(1).replace(/\*$/, '')}...`;
  }
  return '';
}

/** Filter-style empty value (e.g. "Tous les statuts") — user must be able to select it again. */
export function isSelectableEmptySelectLabel(text) {
  if (!text || typeof text !== 'string') return false;
  const t = text.trim().toLowerCase();
  return t.startsWith('tous ') || t.startsWith('toutes ') || t.startsWith('toute ') || t === 'tous';
}

/** Inline styles for hint <option> (native selects ignore most CSS classes on options). */
export const SELECT_HINT_OPTION_STYLE = {
  fontWeight: 700,
  color: '#000000',
};

export function isEmptySelectValue(value) {
  return value === '' || value === null || value === undefined;
}

/** "Sélectionner…" / "Choisir…" hints — show when empty but must not be picked from the list. */
export function isNonSelectableSelectPlaceholder(text) {
  if (!text) return false;
  if (isSelectableEmptySelectLabel(text)) return false;
  const t = text.trim().toLowerCase();
  return (
    t.startsWith('sélectionner') ||
    t.startsWith('selectionner') ||
    t.startsWith('choisir') ||
    t.startsWith('choisissez')
  );
}

export function resolveSelectPlaceholder({ placeholder, label, name }) {
  if (placeholder !== undefined && placeholder !== null) return placeholder;
  if (label) {
    const l = label.toLowerCase();
    if (l.includes('client')) return 'Sélectionner un client';
    if (l.includes('site')) return 'Sélectionner un site';
    if (l.includes('équipement') || l.includes('equipement')) return 'Sélectionner un équipement';
    if (l.includes('plan')) return 'Sélectionner un plan';
    if (l.includes('extincteur')) return 'Sélectionner le type d\'extincteur';
    if (l.includes('type')) return 'Sélectionner le type';
    if (l.includes('statut')) return 'Sélectionner un statut';
    if (l.includes('fréquence') || l.includes('frequence')) return 'Choisir une fréquence';
    if (l.includes('état') || l.includes('etat')) return 'Sélectionner l\'état';
    if (l.includes('sauvegarde')) return 'Choisir une sauvegarde';
  }
  if (name === 'clientId') return 'Sélectionner un client';
  if (name === 'siteId') return 'Sélectionner un site';
  if (name === 'equipmentId') return 'Sélectionner un équipement';
  return 'Sélectionner...';
}
